angular.module('jv.ApprovalDir', ['jv.Common.i18n'])
    .run(['$templateCache', function($tc) {
        $tc.put('sentToAlternatesApproverInformation.htm', '' +
            '<div ng-if=\"approver.profilePicUrl\" class=\"approverPicture\">' +
                '<img ng-src=\"{{approver.profilePicUrl}}\" class=\"img-circle\">' +
            '</div>' +
            '<div class="approverColumn">{{approver.name}}</div>'+
            '<div class="statusColumn"><span class=\"approvalStatus\">{{approvalStatus}}</span> <span class=\"approvalDate\">{{approvalDate | localeDateTime: \'shortDate\':\'MM/dd/yyyy\'}}</span><span ng-if=\"relatedToOriginalApproval\" class=\"originalApproval\"> <span>&#124;</span> <span class=\"sentToOriginalApprovalStatus\">{{sentToOriginalApprovalStatus}}</span> <span class=\"sentToOriginalApprovalDate\">{{sentToOriginalApprovalDate | localeDateTime: \'shortDate\':\'MM/dd/yyyy\'}}</span></span></div>' +
            '<div ng-repeat="person in approver.alternateApprovers" class="alternateApproverInformation">'+
            '<span class=\"top-connector\"></span>' +
            '<span class=\"left-connector\"></span>' +
            '<div ng-if=\"person.user.profilePicUrl\" class=\"approverPicture\">' +
                '<img ng-src=\"{{person.user.profilePicUrl}}\" class=\"img-circle\">' +
                '<i class=\"icon icon-profile-circle large green\"></i>' +
            '</div>' +
            '<div class="approverColumn">{{person.user.fullName}}</div>'+
            '<div class="statusColumn"><span class=\"approvalStatus\">{{person.user.approvalStatus}}</span> <span class=\"approvalDate\">{{alternateSent | localeDateTime: \'shortDate\':\'MM/dd/yyyy\'}}</span></div></div>' +
            '<div ng-hide="approvalActions.length == 0" class="approvalActions">' +
                '<div class="approverColumn">&nbsp;</div>' +
                '<div class="statusColumn">' +
                    '<ul class="actns">' +
                        '<li ng-repeat="action in approvalActions">' +
                            '<a ng-click="action.action()">{{action.label}}</a>' +
                        '</li>' +
                    '</ul>' +
                '</div>' +
            '</div>');
    }])
    .run(['$templateCache', function($tc) {
        // TODO: Refactor to TemplateURL
        $tc.put('approverInformation.htm', '' +
            '<span ng-if=\"relatedToAlternate\" class=\"top-connector\"></span>' +
            '<span ng-if=\"relatedToAlternate\"class=\"left-connector\"></span>' +
            '<div ng-if=\"approver.profilePicUrl\" class=\"approverPicture\">' +
                '<img ng-src=\"{{approver.profilePicUrl}}\" class=\"img-circle\">' +
                '<i ng-if=\"relatedToAlternate\" class=\"icon icon-profile-circle large green\"></i>' +
            '</div>' +
            '<div class=\"approverColumn\">' +
                '{{approver.name}} {{withAlternates}}' +
            '</div>' +
            '<div class=\"statusColumn\">' +
                "<span ng-hide=\"approvalActions.length > 0 && !isInInitialState\"><span class=\"approvalStatus\" ng-class='{\"red\": approver.statusKind == \"REJECTED\"}'>{{approvalStatus}}</span> <span class=\"approvalDate\"> {{approvalDate | localeDateTime: 'shortDate':'MM/dd/yyyy'}}</span>" +
                '<ul class=\"actns\">' +
                    '<li ng-repeat=\"action in approvalActions\">' +
                        '<a ng-click=\"action.action()\">{{action.label}}</a>' +
                    '</li>' +
                '</ul>' +
            '</div>' +
            '<div class=\"approvalExtras\" ng-show=\"approvalReplaces || approver.note\">' +
                '<div class=\"approverColumn\">' +
                    '{{approvalReplaces}}' +
                '</div>' +
                '<blockquote class=\"statusColumn note\" ng-bind-html=\"approver.note\"></blockquote>' +
            '</div>');
        }])
    .run(['$templateCache', function($tc) {
        $tc.put('alternateApproverInformation.htm', '' +
            '<div ng-repeat="person in approver.alternateApprovers" ng-class="{approverInformation:$first, alternateApproverInformation:!$first}">' +
                '<span ng-class="{\'top-connector\':$index}"></span>'+
                '<span ng-class="{\'left-connector\':$index}"></span>'+
                '<div ng-if=\"person.user.profilePicUrl\" class=\"approverPicture\">' +
                    '<img ng-src=\"{{person.user.profilePicUrl}}\" class=\"img-circle\">' +
                    '<i ng-if=\"$index\" class=\"icon icon-profile-circle large green\"></i>' +
                '</div>' +
                '<div class="approverColumn">{{person.user.fullName}}</div>' +
                '<div class="statusColumn"><span class=\"approvalStatus\">{{person.user.approvalStatus}}</span> <span class=\"approvalDate\">{{person.user.approvalDate | localeDateTime: \'shortDate\':\'MM/dd/yyyy\'}}</span> </div>' +
            '</div>');
    }])
    .constant('ApprovalActionMap', {
        'APPROVE': 'approveModal()',
        'REJECT': 'rejectModal()',
        'SENDTOALTERNATE': 'openApprovalmodal(true)',
        'SKIP': 'skipApproval(approver.EId)',
        'RESENDAPPROVAL': 'openApprovalmodal(false)'
    })
    .factory('ApprovalActionLabelMap', ['i18n', function(i18n) {
        return {
            'APPROVE': i18n.APPROVE,
            'REJECT': i18n.REJECT,
            'SENDTOALTERNATE': i18n.SENDTOALTERNATE,
            'SKIP': i18n.SKIP,
            'RESENDAPPROVAL': i18n.RESENDREQUEST
        };
    }])
    .factory('ApprovalStatusMap', ['i18n', function(i18n) {
        return {
            'APPROVED': i18n.APPROVED,
            'REJECTED': i18n.REJECTED,
            'RETRACTED': i18n.RETRACTED,
            'SENTTOALTERNATES': i18n.SENTTOALTERNATES,
            'SKIPPED': i18n.SKIPPED,
            'RESENDAPPROVAL': i18n.RESENTAPPROVAL,
            'APPROVALSENT': i18n.APPROVAL_REQUEST_SENT
        };
    }])
    .directive('approverInformation', ['$compile', 'ApprovalStatusMap', 'ApprovalActionLabelMap', 'ApprovalActionMap',  function($compile, approvalStatusMap, approvalLabels, approvalActionMap) {
        return {
            restrict: 'A',
            scope: true,
            link: function(scope, element) {
                scope.$watch('approver', function(approver) {
                    if(angular.isUndefined(approver)) {
                        return;
                    }
                    scope.approvalActions = [];
                    angular.forEach(approver.actions, function(action) {
                        scope.approvalActions.push({label: approvalLabels[action], action: function() {
                            scope.$eval(approvalActionMap[action]);
                        }});
                    });
                    if(approvalStatusMap[approver.statusKind]) {
                        scope.approvalStatus = approvalStatusMap[approver.statusKind];
                        scope.approvalDate = new Date(approver.updated || approver.submitted);
                    }
                    if((approver.statusKind === 'INITIAL' || approver.statusKind === 'APPROVALSENT') && approver.submitted) {
                        scope.approvalStatus = approvalStatusMap['APPROVALSENT'];
                        scope.approvalDate = new Date(approver.submitted);
                        scope.isInInitialState = true;
                    }
                    if(approver.statusKind === 'SENTTOALTERNATES') {
                        scope.sentToOriginalApprovalStatus = approvalStatusMap['APPROVALSENT'];
                        if(angular.isDefined(approver.submitted)) {
                            scope.sentToOriginalApprovalDate = new Date(approver.submitted);
                            element.empty().append($compile(angular.element('<div sent-to-alternate-approver-information ng-init=\"relatedToOriginalApproval=true\" class=\"approverInformation\"></div>'))(scope));
                        } else {
                            element.empty().append($compile(angular.element('<div sent-to-alternate-approver-information class=\"approverInformation\"></div>'))(scope));
                        }
                    } else {
                        /*following condition can evaluate to true only when Approval is approved by original approver*/
                        if(approver.sentToAlternates && approver.alternateApprovers.length && approver.alternateEId === 'snV9Vfw6') {
                            if(approver.overrideByEId === 'snV9Vfw6' || approver.statusKind === 'SKIPPED') {
                                element.empty().append($compile(angular.element('<div alternate-approver-information class=\"approverInformation\">></div>'))(scope));
                                element.append($compile(angular.element('<div all-other-approver-information ng-init=\"relatedToAlternate=true\" class=\"alternateApproverInformation\"></div>'))(scope));
                            }
                        } else{
                            element.empty().append($compile(angular.element('<div all-other-approver-information class=\"approverInformation\"></div>'))(scope));
                        }
                    }
                });
            }
        };
    }])
    .directive('sentToAlternateApproverInformation', ['ApprovalActionMap', 'ApprovalActionLabelMap', 'ApprovalStatusMap', function(approvalActionMap, approvalActionLabelMap, approvalStatusMap) {
        return {
            templateUrl: 'sentToAlternatesApproverInformation.htm',
            link: function(scope) {
                scope.$watch('approver', function(approver) {
                    scope.alternateSent = new Date(approver.sentToAlternates);
                    angular.forEach(approver.alternateApprovers, function(alternate) {
                        alternate.user.approvalStatus = approvalStatusMap[alternate.user.statusKind];
                    });
                });
            }
        };
    }])
    .directive('allOtherApproverInformation', [function() {
        return {
            templateUrl: 'approverInformation.htm',
            link: function(scope) {
                scope.$watch('approver', function(approver) {
                    if(angular.isUndefined(approver)) {
                        return;
                    }
                    if(approver.approvalStatus === 'INITIAL' && angular.isArray(approver.alternateApprovers) && approver.alternateApprovers.length > 0) {
                        scope.withAlternates = '+' + approver.alternateApprovers.length + ' Alternates';
                    }
                    if(angular.isDefined(approver.alternateFor) && angular.isDefined(approver.alternateFor.fullName)) {
                        scope.withAlternates = 'Alternate for ' + approver.alternateFor.fullName;
                    }
                });
            }
        };
    }])
    .directive('alternateApproverInformation', ['ApprovalStatusMap', function(approvalStatusMap) {
        return {
            templateUrl: 'alternateApproverInformation.htm',
            link: function(scope) {
                scope.$watch('approver', function(approver) {
                    if(angular.isUndefined(approver)) {
                        return;
                    }
                    /*alternate approvers*/
                    angular.forEach(approver.alternateApprovers, function(alternate) {
                        alternate.user.approvalStatus = approvalStatusMap['APPROVALSENT'];
                        alternate.user.approvalDate = new Date(approver.sentToAlternates);
                    });
                    /*Original Approver*/
                    approver.user.approvalStatus = approvalStatusMap['SENTTOALTERNATES'];
                    approver.user.approvalDate = new Date(approver.submitted);
                    approver.alternateApprovers.unshift({user: approver.user});
                });
            }
        };
    }]);